import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// Utils
import {red500} from "assets/jss/main";

// Assets
import {ReactComponent as LogoutIcon} from "assets/img/logout.svg";

CancelTooltipButton.propTypes = {
    onClick: PropTypes.func.isRequired
};

function CancelTooltipButton({onClick}) {
    return (
        <div
            onClick={onClick}
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '12px',
                color: red500,
                fontWeight: 600,
                fontSize: '14px',
                width: '220px',
                borderRadius: '8px',
                background: '#FFF',
                boxShadow: '-8px 8px 48px 0px rgba(0, 0, 0, 0.12)',
            }}
        >
            <FormattedMessage id='wms.myPickingMissions.tooltip.cancel.mission' />
            <LogoutIcon />
        </div>
    );
}

export default CancelTooltipButton;
